import { Flex } from "antd"
import React, { memo } from "react"
import { useTranslation } from "react-i18next"

import { SearchBar } from "../../../../../components/Input/SearchBar.tsx"
import { type ProjectTypesFilters } from "../../../redux/templates.types.ts"

interface ProjectTypesTemplatesFiltersProps {
  filters: ProjectTypesFilters
  onSearchChange: (search: string | null) => void
}

export const ProjectTypesTemplatesFilters = memo(
  ({ filters, onSearchChange }: ProjectTypesTemplatesFiltersProps) => {
    const { t } = useTranslation()

    return (
      <Flex
        wrap="wrap"
        gap="small"
        className="py-4 md:p-4 border-b border-gray-200"
      >
        <div className={"flex-1 max-md:basis-60 max-md:grow"}>
          <SearchBar
            placeholder={t("settingsProjectTemplates.searchPlaceholder")}
            defaultValue={filters?.q || undefined}
            onSearch={onSearchChange}
          />
        </div>
      </Flex>
    )
  }
)

ProjectTypesTemplatesFilters.displayName = "ProjectTypesTemplatesFilters"
